import PanelGroup from './PanelGroup';

// export types
export type { PanelGroupProps } from './PanelGroup';

// export components
export { PanelGroupContext } from './PanelGroup';
export { PanelGroup };
export default PanelGroup;
